import { render, staticRenderFns } from "./upload-avatar.vue?vue&type=template&id=1a1b8f8b&scoped=true&"
import script from "./upload-avatar.vue?vue&type=script&lang=js&"
export * from "./upload-avatar.vue?vue&type=script&lang=js&"
import style0 from "./upload-avatar.vue?vue&type=style&index=0&id=1a1b8f8b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1b8f8b",
  null
  
)

export default component.exports